// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"db752783","453":"dca0dbfe","454":"b100ecbd","702":"841c1943"}[chunkId] + ".chunk.js";
};